// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"e266a5a1","367":"a155ecd7","402":"e7f24f5d","840":"0d89de31","886":"648f335d","893":"0d89de31","933":"5d0c3ead","961":"e9143fb7"}[chunkId] + ".chunk.css";
};